/**
 * Page header.
 *
 * One core task per page means one title, one short description, and at most a
 * couple of actions; anything else belongs on a child route.
 */

import type { ReactNode } from 'react'

import { cn } from '../../lib/format'
import { Breadcrumb, type BreadcrumbItem } from './breadcrumb'

export interface PageHeaderProps {
  breadcrumbs: BreadcrumbItem[]
  title: string
  description?: ReactNode
  actions?: ReactNode
  className?: string
}

export function PageHeader({
  breadcrumbs,
  title,
  description,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <header className={cn('flex flex-col gap-3', className)}>
      <Breadcrumb items={breadcrumbs} />
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex flex-col gap-1">
          <h1 className="text-xl font-semibold tracking-tight sm:text-2xl">{title}</h1>
          {description ? (
            <p className="text-muted-foreground max-w-2xl text-sm">{description}</p>
          ) : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
    </header>
  )
}
